























import { Vue, Component, Prop } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import { vueCanvasPoster } from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
import FloatLikeBtn from './FloatLikeBtn.vue';
import { detail } from '../api/index';
import * as config from '../config';

const Modules = namespace('SCSBY20200526');
Vue.use(Popup).use(Button);
@Component({
  components: {
    FloatLikeBtn,
    vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  @Prop() item: any;
  option = config.OPTHINES;

  @Modules.State('votes') votes!: {};

  detailData: any = {};
  GradeData: any;
  explain = '';
  content = '';
  showCanvas = false;
  src = '';
  painting = {};
  created() {
    detail(this.$route.query.id).then((res) => this.getPainting(res));
  }
  getPainting(res: any) {
    this.detailData = res.data;
    // 年级
    for (const index of Object.keys(this.option.Grades)) {
      let res = '';
      if (Number(index) === this.detailData.content.grade - 1) {
        res = this.option.Grades[Number(index)];
        this.GradeData = res;
      }
    }
    if (this.detailData.nickname === '') {
      this.explain = '上游新闻邀你为我的作文点赞';
    } else {
      this.explain = this.detailData.nickname + '邀你为我的作文点赞';
    }
    // 内容
    this.content = this.detailData.content.content
      .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, '')
      .replace(/&nbsp;/g, '')
      .replace(/<[^>]+?>/g, '')
      .replace(/\s+/g, ' ')
      .replace(/ /g, ' ')
      .replace(/>/g, ' ');
    // 开始绘制
    this.painting = {
      width: '600px',
      height: '1100px',
      background: '#f4f5f7',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/banner.png'),
          css: {
            top: '20px',
            left: '25px',
            width: '550px',
            height: '300px',
            mode: 'scaleToFill',
          },
        },
        // 学生姓名
        {
          type: 'text',
          id: 'student',
          text: this.detailData.content.student,
          css: {
            top: ['40px', 'cover'],
            left: '25px',
            color: '#000',
            fontSize: '36px',
            fontWeight: 'bold',
          },
        },
        // 班级
        {
          type: 'text',
          id: 'grade',
          text:
            this.detailData.content.school +
            this.GradeData +
            this.detailData.content.class +
            '班',
          css: {
            top: ['350px', 'student'],
            left: '25px',
            color: '#000',
            fontSize: '36px',
            fontWeight: 'bold',
          },
        },
        // 分割线
        {
          type: 'rect',
          id: 'divider',
          css: {
            top: '460px',
            left: '25px',
            height: '1px',
            width: '550px',
            color: '#ccc',
          },
        },
        // 标题
        {
          type: 'text',
          id: 'title',
          text: '《' + this.detailData.content.title + '》',
          css: {
            top: '485px',
            left: '15px',
            color: '#666666',
            fontSize: '36px',
            width: '550px',
            lineHeight: '45px',
            maxLines: 2,
          },
        },
        // 指导老师
        {
          type: 'text',
          id: 'teacher',
          text: '指导老师：' + this.detailData.content.teacher,
          css: {
            top: '565px',
            left: '25px',
            color: '#666666',
            fontSize: '30px',
            width: '500px',
          },
        },
        // 正文
        {
          type: 'text',
          text: this.content,
          css: {
            top: '630px',
            left: '25px',
            color: '#666666',
            fontSize: '30px',
            width: '550px',
            lineHeight: '45px',
            maxLines: 3,
          },
        },
        {
          type: 'text',
          text: this.explain,
          css: {
            bottom: '290px',
            left: '130px',
            color: '#666666',
            fontSize: '24px',
          },
        },
        {
          type: 'image',
          url: require('../assets/erweima.png'),
          css: {
            bottom: '60px',
            left: '190px',
            color: '#000',
            width: '200px',
            height: '200px',
          },
        },
        {
          type: 'text',
          text: '长按二维码保存海报',
          css: {
            bottom: '20px',
            left: '160px',
            color: '#000',
            fontSize: '30px',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
